module.exports = __webpack_public_path__ + "static/media/user1.99ab0fd1.svg";